import React, { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';

import { Country } from 'country-state-city';
import { useFormik } from 'formik';
import { string_required, number } from '../../validation/validationSchema';
import * as Yup from 'yup';
import Select from 'react-select';

import { addBundle, updateBundle } from '../../api-services';
import RatesFieldArray from './RatesFieldArray';
import { createRef } from 'react';

const initialState = {
  country_id: '',
  period: '',
  bundle_type: 'CALL',
  bundle: '',
  status: '',
  // currency: '',
  // cost: '',
  lcr: [],
  provider: '',
  failoverProvider: '',
  type: '',
};

const AddBundle = ({
  setOpenModal,
  openModal,
  editData = {},
  setEditData,
  AllProvidersCall,
  AllProvidersSMS,
  type = '',
}) => {
  const isEdit = editData && Object.keys(editData).length > 0;
  const [initialValues, setInitialValues] = useState(initialState);
  const [countryList, setCountryList] = useState([]);
  const [prevSelectedArr, setPrevSelectedArr] = useState([]);
  const [AllProviders, setAllProviders] = useState([]);
  const [rates, setRates] = useState([]);
  const formikRef = createRef();

  const queryClient = useQueryClient();

  const validationSchema = Yup.object({
    country_id: string_required,
    period: number,
    bundle_type: string_required,
    bundle: number,
    status: string_required,
    // currency: string_required,
    // cost: number,
  });

  const { isLoading: isLoadingAddMember, mutateAsync: mutateAsync1 } =
    useMutation('addBundle', addBundle, {
      onSuccess: (data) => {
        setOpenModal(false);
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
          timer: 3000,
        }).then(() => {
          queryClient.invalidateQueries('bundleListing');
          queryClient.invalidateQueries('callBundleListingSMS');
          queryClient.invalidateQueries('callBundleListingVN');
          queryClient.invalidateQueries('callBundleListingCALL');
          handleClose();
        });
      },
      onError: (error) => {
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    });
  const { isLoading: isLoadingUpdateBundle, mutateAsync: mutateUpdate } =
    useMutation('updateBundle', updateBundle, {
      onSuccess: (data) => {
        setOpenModal(false);
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
          timer: 3000,
        }).then(() => {
          queryClient.invalidateQueries('bundleListing');
          queryClient.invalidateQueries('callBundleListingSMS');
          queryClient.invalidateQueries('callBundleListingVN');
          queryClient.invalidateQueries('callBundleListingCALL');
          handleClose();
        });
      },
      onError: (error) => {
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    });

  const handleSubmitForm = async (values) => {
    const {
      currency,
      cost,
      period,
      provider,
      status,
      failoverProvider,
      lcr,
      ...rest
    } = values;
    const payload = {
      ...rest,
      lcr: lcr?.map((val) => val?.value) ?? [],
      period: Number(period),
      provider: Number(provider),
      status: Number(status),
      failoverProvider: Number(failoverProvider),
      rates: formikRef.current?.values?.addRates ?? [],
      // rates: {
      //   currency,
      //   cost,
      // },
    };

    if (isEdit) {
      payload.bundle_unicode = editData?.bundle_unicode;
      await mutateUpdate(payload);
    } else {
      await mutateAsync1(payload);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: !isEdit && validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const handlePreviousSelected = (valArr) => {
    if (valArr?.length > 0) {
      const mutatedArr =
        AllProviders?.filter((val) => valArr?.includes(val.providerID))?.map(
          (newVal) => ({ value: newVal?.providerID, label: newVal?.name }),
        ) ?? [];

      setPrevSelectedArr(mutatedArr);
    }
  };

  useEffect(() => {
    const countries = Country.getAllCountries();
    setCountryList(countries);
    return () => formik.resetForm();
  }, []);

  useEffect(() => {
    if (formik.values.bundle_type === 'CALL') {
      setAllProviders(AllProvidersCall);
    } else {
      setAllProviders(AllProvidersSMS);
    }
  }, [formik?.values?.bundle_type]);

  useEffect(() => {
    if (AllProviders?.length > 0) {
      handlePreviousSelected(editData?.lcr);
    }
  }, [AllProviders]);

  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      const {
        bundle,
        countries,
        period,
        bundle_type,
        status,
        rates,
        provider,
        failoverProvider,
        type,
      } = editData;

      const payload = {
        country_id: countries?.alpha2code,
        period: period?.toString(),
        bundle_type: bundle_type,
        bundle: bundle?.toString(),
        status: status?.toString(),
        // currency: rates?.[0]?.currency,
        // cost: rates?.[0]?.cost,
        provider: provider ? provider : '',
        failoverProvider: failoverProvider ? failoverProvider : '',
        type: type,
      };
      setInitialValues(payload);
    }
  }, [editData]);

  const selectProvider = (
    <div className="form-group input_control">
      <div className="w-100">
        <select
          className="form-control"
          name="provider"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.provider}
        >
          <option value="">Please select provider</option>
          {AllProviders?.map(({ providerID, name }, index) => (
            <option value={providerID} key={index}>
              {name}
            </option>
          ))}
        </select>
        {/* {formik.touched.provider && formik.errors.provider ? (
          <div className="error_required">{formik.errors.provider}</div>
        ) : null} */}
      </div>
    </div>
  );
  const selectProviderLCR = (
    <div className="form-group input_control">
      <div className="w-100">
        <Select
          placeholder="Select provider..."
          options={AllProviders?.map(({ providerID, name }, index) => {
            return { value: providerID, label: name };
          })}
          isMulti={true}
          defaultValue={prevSelectedArr}
          name="lcr"
          onChange={(val) => formik.setFieldValue('lcr', val)}
        />
      </div>
    </div>
  );
  const selectFailOverProvider = (
    <div className="form-group input_control">
      <div className="w-100">
        <select
          className="form-control"
          name="failoverProvider"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.failoverProvider}
        >
          <option value="">Please select failover provider</option>
          {AllProviders?.map(({ providerID, name }, index) => (
            <option value={providerID} key={index}>
              {name}
            </option>
          ))}
        </select>
        {/* {formik.touched.failoverProvider && formik.errors.failoverProvider ? (
          <div className="error_required">{formik.errors.failoverProvider}</div>
        ) : null} */}
      </div>
    </div>
  );

  const handleProvider = (type) => {
    switch (type) {
      case 'Provider':
        return (
          <>
            {selectProvider}
            {selectFailOverProvider}
          </>
        );
      case 'LCR':
        return <>{selectProviderLCR}</>;

      default:
        return null;
    }
  };

  const handleRouting = (type) => {
    switch (type) {
      case 'CALL':
        return (
          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="type"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.type}
              >
                <option value="">Please select type</option>
                <option value="Provider" key="1">
                  Provider
                </option>
                <option value="LCR" key="2">
                  LCR
                </option>
              </select>
              {/* {formik.touched.type && formik.errors.type ? (
                <div className="error_required">{formik.errors.type}</div>
              ) : null} */}
            </div>
          </div>
        );
      case 'SMS':
        return (
          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="type"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.type}
              >
                <option value="">Please select type</option>
                <option value="Provider" key="1">
                  Provider
                </option>
              </select>
              {/* {formik.touched.type && formik.errors.type ? (
                <div className="error_required">{formik.errors.type}</div>
              ) : null} */}
            </div>
          </div>
        );

      default:
        return (
          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="type"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.type}
              >
                <option value="">Please select type</option>
                <option value="Provider" key="1">
                  Provider
                </option>
                <option value="LCR" key="2">
                  LCR
                </option>
              </select>
              {/* {formik.touched.type && formik.errors.type ? (
                <div className="error_required">{formik.errors.type}</div>
              ) : null} */}
            </div>
          </div>
        );
    }
  };

  useEffect(() => {
    if (formik.values.type) {
      if (formik.values.type === 'Provider') {
        formik.setFieldValue('lcr', []);
        setPrevSelectedArr([]);
      }
      if (formik.values.type === 'LCR') {
        formik.setFieldValue('lcr', prevSelectedArr);
        formik.setFieldValue('provider', '');
        formik.setFieldValue('failoverProvider', '');
      }
    }
  }, [formik.values.type]);

  const handleClose = () => {
    setOpenModal(false);
    setEditData({});
    formik.resetForm();
  };

  const bundleTypes =
    type === 'Call'
      ? [{ label: 'Call', value: 'CALL' }]
      : [{ label: 'SMS', value: 'SMS' }];

  return (
    <Modal
      size="md"
      centered
      show={openModal}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-header ">
          <div className="icon_arrow"></div>
          <h5 className="modal-title heading heading--xs mb-0 ">
            {isEdit ? 'Edit' : 'Add'} Bundle
          </h5>
        </div>

        <div className="modal-body">
          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="country_id"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.country_id}
              >
                <option value="">Please select country</option>
                {countryList?.map((c, i) => (
                  <option value={c.isoCode} key={i}>
                    {c.name}
                  </option>
                ))}
              </select>
              {formik.touched.country_id && formik.errors.country ? (
                <div className="error_required">{formik.errors.country}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="period"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.period}
              >
                <option value="">Please select period</option>
                <option value={1} key="1">
                  1 month
                </option>
                <option value={3} key="2">
                  3 months
                </option>
                <option value={12} key="3">
                  12 months
                </option>
              </select>
              {formik.touched.period && formik.errors.period ? (
                <div className="error_required">{formik.errors.period}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="bundle_type"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.bundle_type}
              >
                <option value="">Please select bundle type</option>
                {bundleTypes?.map((bundle, index) => (
                  <option value={bundle?.value} key={index}>
                    {bundle?.label}
                  </option>
                ))}
              </select>
              {formik.touched.bundle_type && formik.errors.bundle_type ? (
                <div className="error_required">
                  {formik.errors.bundle_type}
                </div>
              ) : null}
            </div>
          </div>
          {handleRouting(formik.values.bundle_type)}
          {handleProvider(formik.values.type)}
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <input
                type="number"
                step="any"
                className="form-control"
                placeholder={
                  formik.values.bundle_type === 'CALL' ? 'Minutes' : 'SMS'
                }
                name="bundle"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.bundle}
              />
              {formik.touched.bundle && formik.errors.bundle ? (
                <div className="error_required">{formik.errors.bundle}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control">
            <div className="w-100">
              <select
                className="form-control"
                name="status"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.status}
              >
                <option value="">Please select status</option>
                <option value="1" key="1">
                  Activate
                </option>
                <option value="0" key="2">
                  Deactivate
                </option>
              </select>
              {formik.touched.status && formik.errors.status ? (
                <div className="error_required">{formik.errors.status}</div>
              ) : null}
            </div>
          </div>
          <>
            <div className="form-group input_control input_control--gap">
              <div className="w-100">
                <h5>Bundle Rates</h5>
              </div>
            </div>
            {/* <Row>
              <Col>
                <div className="form-group input_control">
                  <div className="w-100">
                    <select
                      className="form-control"
                      name="currency"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.currency}
                    >
                      <option value="">Please select currency</option>
                      <option value="EURO" key="1">
                        EURO
                      </option>
                      <option value="XOF" key="2">
                        XOF
                      </option>
                      <option value="USD" key="2">
                        USD
                      </option>
                      <option value="GBP" key="2">
                        GBP
                      </option>
                    </select>
                    {formik.touched.currency && formik.errors.currency ? (
                      <div className="error_required">
                        {formik.errors.currency}
                      </div>
                    ) : null}
                  </div>
                </div>
              </Col>
              <Col>
                <div className="form-group input_control input_control--gap">
                  <div className="w-100">
                    <input
                      type="number"
                      step="any"
                      className="form-control"
                      placeholder="amount"
                      name="cost"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.cost}
                    />
                    {formik.touched.cost && formik.errors.cost ? (
                      <div className="error_required">{formik.errors.cost}</div>
                    ) : null}
                  </div>
                </div>
              </Col>
            </Row> */}

            <RatesFieldArray
              setRates={setRates}
              rates={rates}
              ref={formikRef}
              editRates={editData?.rates ?? []}
            />
          </>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            disabled={isLoadingAddMember || isLoadingUpdateBundle}
            className="btn btn-danger"
            onClick={() => handleClose()}
          >
            Close
          </button>

          <button
            type="submit"
            disabled={isLoadingAddMember || isLoadingUpdateBundle}
            className="btn btn-dark-blue"
          >
            {isLoadingAddMember || isLoadingUpdateBundle
              ? 'Please Wait...'
              : 'Submit'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddBundle;
